import type { AuthUserDto } from '../schemas/auth'

export function hasRole(user: Pick<AuthUserDto, 'roles'> | null | undefined, key: string) {
  return Boolean(user?.roles.some((role) => role.key === key))
}

export function userHasPermission(
  user: Pick<AuthUserDto, 'permissions'> | null | undefined,
  permission: string,
) {
  return Boolean(
    user?.permissions.includes(permission as never) ||
    user?.permissions.includes('tenant.*' as never),
  )
}

export function safeRedirect(value: unknown, fallback = '/') {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\')
  )
    return fallback
  try {
    const parsed = new URL(value, 'http://morning.local')
    return parsed.origin === 'http://morning.local'
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : fallback
  } catch {
    return fallback
  }
}
